import { createContext, useContext } from 'react';
import { NavigationType, useNavigationType } from 'react-router-dom';

export const ShellNavigationTypeContext = createContext<NavigationType | null>(
  null,
);

export function useShellNavigationType() {
  const routerNavigationType = useNavigationType();

  return useContext(ShellNavigationTypeContext) ?? routerNavigationType;
}
